export const baseUrl = "https:////app.aviationnetwork.com"

export function upload(options) {
    if (options.headers === undefined) options.headers = {}
    options.headers.authorization = "Bearer " + sessionStorage.getItem("token")

    return fetch(`${baseUrl}/api/index.php/upload`, options)
}

export function login(options) {
    return fetch(`${baseUrl}/login.php`, options)
}

export function reset(options) {
    return fetch(`${baseUrl}/reset.php`, options)
}

export function signup(options) {
    return fetch(`${baseUrl}/signup.php`, options)
}

export default (url, options = {}) => {
    if (options.headers === undefined) options.headers = {}
    options.headers.authorization = "Bearer " + sessionStorage.getItem("token")

    return fetch(`${baseUrl}/api/index.php/${url}`, options)
}



/** WEBPACK FOOTER **
 ** ./src/actions/api.js
 **/